<template>
  <div class="simple-product" @click="jump">
    <swiper class="product-image" :config="swiperConfig">
      <div class="swiper-slide" v-for="(img, index) in data.images" v-key="index">
        <div class="cover-line left"></div>
        <div class="cover-line right"></div>
        <beast-image v-if="data._big" :lazy="true" :src="data.bigPic.src" />
        <beast-image v-else :lazy="true" :src="img" />
        <!-- <div class="foretell-box" v-if="data.foretell">
          <div class="foretell">即将开售</div>
        </div> -->
        <!-- <div class="activity-desc" v-if="data.activityDesc">
          <div class="desc">{{ data.activityDesc }}</div>
        </div> -->
        <div class="corner-box" v-if="data.foretell">
          <div class="stats-tag" :class="{big: data._big}">
            <span>即将开售</span>
          </div>
        </div>
        <div class="corner-box" v-if="data.offShelf">
          <div class="stats-tag" :class="{big: data._big}">
            <span>下架</span>
          </div>
        </div>
        <div class="corner-box" v-else-if="data.soldOut">
          <div class="stats-tag" :class="{big: data._big}">
            <span>售罄</span>
          </div>
        </div>
        <div class="add-cart" v-if="addToCart" @click.stop="addCart">
          <beast-image src="http://img.thebeastshop.com/apppictures/2017-07-12/6066758d9fb8834c2f2f6a9e4a085fa1.png" />
        </div>
      </div>
    </swiper>
    <div class="product-infos">
      <div class="summary" v-if="data.activityDesc">{{data.activityDesc}}</div>
      <div class="tag" v-if="data.customizable">定制</div>
      <div class="tag" v-else-if="data.isOversea">跨境商品</div>
      <div class="brand-name">{{data.brand && data.brand.name}}</div>
      <div class="name">{{data.name}}</div>
      <div class="prices newn" v-if="data.newcomerTag && !data.newcomerUsed">
        <div class="price discount-price"> <price :data="data.price" /><span class="newn-tag">新人价</span></div>
        <del class="price raw-price" v-if="data.price < data.rawPrice"><price :data="data.rawPrice"/></del>
      </div>
      <div class="prices" v-else>
        <div class="price discount-price"> <price :data="data.price" /></div>
        <del class="price raw-price" v-if="data.price < data.rawPrice"><price :data="data.rawPrice"/></del>
      </div>
      <div class="stock-warn" v-if="data.stockWarn">{{data.stockWarn || ''}}</div>
    </div>
    <div class="refund" v-if="data.refunds">约返{{data.refunds | formatPrice}}元</div>
  </div>
</template>

<script>
  import price from '@/price'
  import swiper from '@/swiper/swiper-4.4.6/index.vue'
  import beastImage from '@/components/image'
  import bridge from '@beastshop/bridge'
  import browser from '@beastshop/browser'
  import axios from '@/axios-mock'
  import track from '@/track'
  import { lazyload } from '@/lazyload'
  import { ensure_protocol } from '@beastshop/url-util'

  const headers = {}
  // if (process.env.NODE_ENV === 'development') {
  //   Object.assign(headers, {
  //     'Authorization': 'f85abb3c-9304-44de-b8fe-5bebe4055926',
  //     'Platform': 'Android/24',
  //     'TBS-Source': 1
  //   })
  // }


  const vipLevelImages = {
    '0': 'http://img.thebeastshop.com/apppictures/2017-07-12/5f7fdc7bd73dc83f4318a918cfb771ac.jpg',
    '1': 'http://img.thebeastshop.com/apppictures/2017-07-12/9460e395b4ee15b1f8426b9f5d87e1a0.png',
    '2': 'http://img.thebeastshop.com/apppictures/2017-07-12/65decd7cdc9d6f45fd34dfa4aaf2ba8b.png',
    '3': 'http://img.thebeastshop.com/apppictures/2017-07-12/cc963fc32858fbf03e6d9b80d842d8e9.png',
  }

  export default {
    name: 'simple-product',
    props: {
      data: {
        type: Object,
        require: true
      },
      index: {
        type: Number
      },
      addToCart: {
        type: Boolean,
        default: false
      },
      searchKey : {
        type: String
      },
      sdk: Object,
      env: String,
      isJump: {
        type: Boolean,
        default: true
      },
      business: {
        type: String
      }
    },
    data () {
      return {
        _images: [],
        swiperConfig: {
          loop: true
        }
      }
    },
    components: {
      price,
      beastImage,
      swiper
    },

    created () {
      this.data.images.shift()
      this.data.images.unshift(this.data.featureImage)
    },

    mounted () {
      lazyload()
    },
    filters: {
      formatPrice (value) {
        let v = String(Math.floor(value*Math.pow(10,1)) / Math.pow(10,1))
        const temp = v.split('.')
        return temp.length > 1 
          ? v
          : `${v}.0`
      }
    },
    computed: {
      productImage: function () {
        const data = this.data
        return data.featureImage
          ? data.featureImage
          : data.images
            ? data.images[0]
            : ''
      },
      priceTags: function () {
        let data = this.data
        if (data.discount) {
          return {
            vipLevelImage: data.discount.vipLevel !== null && vipLevelImages[data.discount.vipLevel],
            // appOnlyImage: data.discount.appOnly && 'http://img.thebeastshop.com/apppictures/2017-07-12/a139293dcdbcd72afa4d2b77a5698d42.png',
            birthdayImage: data.discount.birthday && 'http://img.thebeastshop.com/apppictures/2017-07-12/7860dfcf031b72f2d3bf0c14b3e6f7c3.png'
          }
        } else {
          return {}
        }
      }
    },
    methods: {
      jump () {
        
        let _suggestType = this.data.markInfo ? JSON.parse(this.data.markInfo).RecommendType : ''
        if (!this.isJump) return
        switch (this.env) {
          case 'm-web':
            window.location.href = `/product/${this.data.id}?suggestType=${encodeURIComponent(_suggestType)}`
            break
          case 'wx-web': 
            window.location.href = `/product/${this.data.id}?suggestType=${encodeURIComponent(_suggestType)}`
            break
          case 'miniprogram':
            const linkData = {
              url: `/pages/product/detail/detail?code=${this.data.id}`,
              mpType: 'navigate'
            } 
            this.sdk.navigate.jumpTo(linkData)
            break
          case 'app':
            bridge.open({
              url: `beastapp://product/${this.data.id}?suggestType=${encodeURIComponent(_suggestType)}`
            })
            break
          default:
            window.location.href = `/product/${this.data.id}?suggestType=${encodeURIComponent(_suggestType)}`
            break
        }
      
        if (this.searchKey) {
          sa.track('SearchResultClick', {
            search_word: this.searchKey,
            position_number: this.index - 0 + 1,
            commodity_spu_id: this.data.id,
            commodity_name: this.data.name,
            hot_label: sa.getActivity(this.data.labels),
            original_price: this.data.rawPrice,
            discount_price: this.data.price
          })
        }
        else {
          const bu = this.data.recommendEngine ? `猜你喜欢-${this.data.recommendEngine}`: '猜你喜欢'
          sa.track('CommodityClick', {
            position_number: this.index - 0 + 1,
            commodity_spu_id: this.data.id,
            commodity_name: this.data.name,
            hot_label: [],
            original_price: this.data.rawPrice,
            discount_price: this.data.price,
            business_case: this.business === 'suggest' ? bu : '其他'
          })
        }

        if (this.data.markInfo) {
          // this.data.markInfo = JSON.parse(this.data.markInfo) || null

          track({
            name: 'click-result-suggest',
            attrs: {
              suggestType: _suggestType
            },
            productId: this.data.id
          })
        }
      },

      getVariant () {
        return axios({
          headers,
          url:`/app/product/${this.data.id}/spvs`,
          method: 'GET'
        })
      },

      selectVariant () {
        return this.$selectVariant({
          pack: this.transform(this.variant.spvs[0]),
          variant: this.variant,
          selectAmount: true
        })
          .then((result) => {
            return Promise.resolve({ result })
          })
      },

      transform(spv) {
        return {
          product: {
            brand: {
              name: spv.brand ? spv.brand.name : ''
            },
            name: spv.name,
          },
          count: spv.minAmount || 1,
          variant: spv.id
        }
      },

      toCart ( result ) {
        this.$showLoading()
        this.add(result.spvId, result.count)
          .then(({code, data}) => {
            this.$hideLoading()
            this.$toast('加入购物车成功！')
            if (browser.app()) {
              bridge.broadcast({
                type: 'refreshPreview'
              })
              bridge.notify('cart_size_change')
            }
            this.$emit('after-add')
          })
          .catch(({ message }) => {
            this.$hideLoading()
            this.$alert(message)
          })
      },

      add (spvId, count = 1) {
        return axios({
          headers,
          url: '/app/cart/packs',
          method: 'POST',
          json: [{
            spvId: spvId,
            count: count,
            source: 'RAW'
          }]
        })
      },

      addCart () {
        this.$showLoading()
        this.getVariant()
          .then(({ data }) => {
            this.$hideLoading()
            this.variant = data
            if (this.variant.spvs.length > 1) {
              this.selectVariant()
                .then(({ result }) => {
                  if (!result) {
                    return
                  }
                  this.toCart(result)
                })
            } else {
              let spv = this.variant.spvs[0]
              this.toCart({
                spvId: spv.id,
                count: spv.minAmount || 1
              })
            }
          })
          .catch(({ message }) => {
            this.$hideLoading()
            this.$alert(message)
          })

        }


        // axios({
        //   url: '/app/cart/packs',
        //   method: 'POST',
        //   json: [{
        //     spvId: this.data.spv.id,
        //     count: 1,
        //     source: "RAW"
        //   }]
        // })
        //   .then(() => {
        //     this.$hideLoading()
        //     this.$toast('加入购物车成功！')
        //     this.$emit('after-add', this.data)
        //   })
        //   .catch(({ message }) => {
        //     this.$hideLoading()
        //     this.$alert(message)
        //   })
      }
    }
</script>

<style lang="stylus">
  @import '../../common/styl/global.styl'

  .simple-product
    font-size rem(13)
    width rem(186.5)
    &.big
      width rem(375)
      height auto
      .product-image
        position relative
        width 100%
        height auto
    .swiper-slide
      position relative
      .cover-line
        position absolute
        z-index 9
        width rem(1)
        height rem(195)
        background #fff
        top 0
        &.left
          left rem(-0.5)
        &.right 
          right rem(0.5)
    .product-image
      position relative
      width 100%
      height rem(195)
      margin-bottom rem(7)
      img
        width 100%
        height 100%
      .foretell-box
        position absolute
        top rem(12)
        right rem(12)
        width rem(32)
        height rem(32)
        box-sizing border-box
        border rem(1.5) solid #5C7D82
        background rgba(218, 229, 231, .95) none repeat scroll !important
        .foretell
          position relative
          width 100%
          top 50%
          transform translateY(-50%)
          font-size rem(11)
          line-height rem(12)
          color #5C7D82
          font-weight bold
          span-align center
      .activity-desc
        width 100%
        height rem(24)
        // line-height rem(17)
        padding 0 rem(5) rem(5)
        box-sizing border-box
        position absolute
        left 0
        bottom 0
        .desc
          display inline-block
          max-width 100%
          // height 100%
          line-height rem(19)
          padding 0 rem(6)
          background #f2f2f2 none repeat scroll !important
          opacity 0.95
          box-sizing border-box
          color #537371
          font-size rem(10)
          font-weight bold
          overflow hidden
          span-overflow ellipsis
          white-space nowrap
      .corner-box
        position absolute
        top 0
        right 0
        left 0
        bottom 0
        background rgba(255, 255, 255, .5) none repeat scroll !important
        overflow hidden
        .stats-tag
          position absolute
          top rem(6)
          right rem(6)
          width rem(35)
          height rem(35)
          border solid rem(1.5) #000
          font-size rem(10)
          font-weight bold
          text-align center
          background #fff
          color #000
          span
            display inline-block
            position absolute
            width rem(22)
            top 50%
            left 50%
            transform translate(-50%, -50%)
          &.big
            width rem(50)
            height rem(50)
            border solid rem(2) #000
            font-size rem(14)
            span
              width rem(31)
      .add-cart
        width rem(36)
        height rem(36)
        position absolute
        right rem(9)
        bottom rem(9)
        z-index 1
    .product-infos
      overflow hidden
      padding-left rem(15)
      color #000
    .summary
      height rem(13)
      line-height rem(13)
      font-weight bold
      padding rem(5) 0
      ellipsis()
      color #C44747
    .name, .brand-name
      ellipsis()
      line-height rem(17)
    .tag
      ellipsis()
      font-weight bold
    .prices
      float left
      padding-top rem(6)
      clearfix()
      &.newn
        .newn-tag
          display inline-block
          width rem(42)
          height rem(17)
          margin-left rem(5)
          font-size rem(10)
          font-weight bold
          line-height rem(17)
          border-radius rem(2)
          text-align center
          background #F5F5F5
          color #DD4F14
          &::before
            content ''
            display inline-block
            vertical-align middle
            width 0
            height 100%
            margin-top rem(1)
        .discount-price
          float none
          display block
        .raw-price
          float none
          display block
          margin-left 0
      .price
        font-size rem(15)
        float left
        color #000
        font-weight bold
        .decimal
          font-size rem(10)
      .raw-price
        color #C9C9C9
        font-size rem(12)
        font-weight normal
        float left
        line-height rem(18)
        margin-left rem(4)
      .tags-wrap
        margin-left rem(10)
        float left
        clearfix()
        .price-tag
          float left
          width rem(15)
          height rem(15)
          margin-right rem(2)
          img
            width 100%
            height 100%
        .panic-tag
          float left
          padding rem(3) rem(2)
          background #C44747
          color #fff
          font-size rem(9)
          line-height rem(9)
          font-weight bolder   
.simple-product
  .stock-warn
    float left
    padding-top rem(6)
    margin-left rem(6)
    height rem(17)
    line-height rem(17)
    font-weight bold
    font-size rem(12)
    color #c44747
  .refund
    display inline-block
    margin-left rem(14)
    margin-top rem(5)
    padding rem(3) rem(5)
    border solid rem(1) #C44747
    font-size rem(10)
    font-weight bold
    color #C44747
</style>



// WEBPACK FOOTER //
// index.vue?4cc15d32